import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import LoadedFile from './LoadedFile'
import DictionaryService from "../api/DictionaryService"
import './ProfileDS.css'
import { base_url } from '../api/index'

function InfoDS({ user }) {
    const userStatus = user.status
    const isUserConfirmed = userStatus === 'confirmed' ? true : false
    const role = user.role
    const [company, setCompany] = useState(null)
    const [logo, setLogo] = useState(null)
    const [files, setFiles] = useState([])
    const [edit_region, set_edit_region] = useState(null)
    const [description, setDescription] = useState(null)
    const [isHasInfo, setInfo] = useState(false)
    const [msg, setMsg] = useState('')
    useEffect(() => {
        // if (isUserConfirmed) {
            const url = new URL(window.location.href)
            let uid = url.searchParams.get('uid')
            if (uid) {
                setMsg('Получение информации о держателе сертификата')
                DictionaryService.getAllDSUsers(uid).then(response => {
                    const data = response.data
                    if (data.ok) {
                        const DS = data.message
                        const index = DS.findIndex(val => val.id === uid)
                        console.log(index)
                        if (index === -1) {
                            setMsg('Такого держателя сертификата не существует')
                            return
                        }
                        setInfo(true)
                        const user_data = DS[index]
                        setCompany(user_data.object.ae9dd1b1032daaed7cc9638180dc6318b.Company.value || '')
                        setLogo(user_data.object.c1[0].oUploadFile.UpFile.src ? base_url + 'file/' + user_data.object.c1[0].oUploadFile.UpFile.src : null)
                        setDescription(user_data.object.ae9dd1b1032daaed7cc9638180dc6318b.compDesc || '')
                        set_edit_region(user_data.object.ae9dd1b1032daaed7cc9638180dc6318b.region.value || '')
                        if (user_data.object.a0f3e8bf4c6261bc97ae84d79783e005)
                            setFiles(user_data.object.a0f3e8bf4c6261bc97ae84d79783e005.files)
                    } else {
                        setMsg('Ошибка получения информации о деражетеле сертификата')
                    }
                }).catch(() => {
                    setMsg('Ошибка сети')
                })
            } else {
                setMsg('Такого держателя сертификата не существует')
            }
        // }
    }, [])

    return (
        <>
            {isHasInfo && /*isUserConfirmed &&*/
                <section className='profile-ds'>
                    <p className='profile-ds__title'>Информация о держателе сертификата</p>
                    <p className='profile-ds__title-field mb-16'>Наименование компании:</p>
                    <p>{company}</p>
                    <p className='profile-ds__title-field'>Логотип:</p>
                    {logo ? <img className='profile-ds__logo' src={logo} alt='Логотип компании' /> : 'Нет логотипа'}
                    <p className='profile-ds__title-field'>Регион:</p>
                    <p>{edit_region ? edit_region : 'Не указан'}</p>
                    <p className='profile-ds__title-field'>Краткое описание:</p>
                    {description ? description : 'Нет описания'}
                    <p className='profile-ds__title-field'>Нормативные и информативные документы:</p>
                    {files && files.length > 0 ? files.map((file, i) => <LoadedFile file={file} id={i} remove={false} />) : 'Нет документов'}
                </section>}
            {!isHasInfo && /*isUserConfirmed &&*/
                <p>{msg}</p>
            }
            {/* {userStatus === "unregistered" &&
                <p>Страница доступна только авторизованным пользователям</p>
            } */}
            {/* {isUserConfirmed && role !== 'e249a07138dd45d3f4ba27d90d6c2244d' &&
                <p>Страница доступна только пользователям роли 'Держатель сертификата FSC'</p>} */}
            {/* {userStatus === 'unregistered' &&
                <p>Страница доступна только авторизованным пользователям</p>} */}
        </>
    )
}

const mapStateToProps = state => ({
    user: state.user
})

export default connect(mapStateToProps, {})(InfoDS)